import { AuthUser } from '../types/auth';

export function getCompanyZoneEnabled(user: AuthUser | undefined): boolean {
    const hasZoneEnabled = user?.companyConfig?.some(config => config.zoneEnabled === true);
    return !!hasZoneEnabled;
}

export function getCanShowHierarchyToggle(
    user: AuthUser | undefined,
    companyZoneEnabled: boolean,
): boolean {
    if (user?.roleList?.some((role) => role.roleName === 'SuperAdmin')) {
        console.log('super user gets everything');
        return true;
    } else {
        return (
            companyZoneEnabled &&
            !!user?.roleList?.some((role) => role.roleName === 'CompanyAdmin')
        );
    }
}

export function getDefaultModeForUser(
    user: AuthUser | undefined,
    companyZoneEnabled: boolean,
): 'DEPARTMENT' | 'ZONE' {
    // If toggle is not allowed, set default mode:
    if (!companyZoneEnabled) return 'DEPARTMENT';

    if (user?.roleList?.some((r) => r.roleName === 'DepartmentAdmin')) {
        return 'DEPARTMENT';
    }
    if (user?.roleList?.some((r) => r.roleName === 'ZoneAdmin')) {
        return 'ZONE';
    }
    // Fallback: for any other roles in a zoned company, default to ZONE
    return 'DEPARTMENT';
}
